var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2135 9.17578C18.2135 9.17578 17.7157 15.3495 17.427 17.9501C17.2895 19.1922 16.5222 19.92 15.2655 19.9429C12.8739 19.986 10.4796 19.9888 8.08891 19.9384C6.87983 19.9136 6.12541 19.1766 5.99066 17.9565C5.70008 15.333 5.20508 9.17578 5.20508 9.17578",
    stroke: "#FF0909",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4823 6.21615H3.9375",
    stroke: "#FF0909",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4861 6.21778C15.7665 6.21778 15.1468 5.70903 15.0056 5.00411L14.7829 3.88945C14.6454 3.3752 14.1797 3.01953 13.649 3.01953H9.76872C9.23797 3.01953 8.77231 3.3752 8.63481 3.88945L8.41206 5.00411C8.27089 5.70903 7.65122 6.21778 6.93164 6.21778",
    stroke: "#FF0909",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightDelete);
export default __webpack_public_path__ + "static/media/light-delete.e8ed68306bf41bc822e000603979991d.svg";
export { ForwardRef as ReactComponent };